import * as React from "react"

const Image = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width="16" height="16" viewBox="0 0 16 16" {...props}>
    <path
      d="M1.5 2.5a1 1 0 0 1 1-1h11a1 1 0 0 1 1 1v11a1 1 0 0 1-1 1h-11a1 1 0 0 1-1-1v-11Zm12 0h-11v11h.3l7.35-7.35.35-.36.35.36 2.65 2.64V2.5Zm0 11H4.2l6.3-6.3 3 3v3.3ZM5.5 6a.5.5 0 1 1 1 0 .5.5 0 0 1-1 0ZM6 4.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3Z"
      fillRule="evenodd"
    />
  </svg>
)

export default Image
